import React from 'react';

const TabGalleryIcons = ({ tabTitle }) => {
  return (
    <React.Fragment>
      {tabTitle === 'Images' && (
        <span key="image-icon" style={{ display: 'inline' }}>
          <i className="material-icons">photo_size_select_actual</i>
        </span>
      )}
      {tabTitle === 'Videos' && (
        <span key="video-icon" style={{ display: 'inline' }}>
          <i className="material-icons">video_library</i>
        </span>
      )}
    </React.Fragment>
  );
};

export default TabGalleryIcons;
